import React from 'react';
import { apiClient } from './ApiClient';
import { session } from '../components/fx';

export const SecurityService = ({ getToken }: any) => {

    const initiateUserSession = async (headers={}) => {
      let token = await getToken();
      session.setItem("accessToken", token);

      let apiOptions: any = {
        url: 'options/InitiateUserSession',
        method: 'post',
        data: null,
        headers
      };
      let result = await apiClient.doAction(apiOptions, token);
      return result;
    }

    const getMyProfile = async (headers={}) => {
      let token = await getToken();
      let apiOptions: any = {
        url: 'users/getMyProfile',
        method: 'post',
        data: null,
        headers
      };
      let result = await apiClient.doAction(apiOptions, token);
      return result;
    }

    const logout = async (headers={}) => {
      let token = await getToken()
      let apiOptions: any = {
        url: 'security/Logout',
        method: 'post',
        data: null,
        headers
      };
      let result = await apiClient.doAction(apiOptions, token);
      return result;
    }

    return { initiateUserSession, getMyProfile, logout };
}